<form
  [class]="merge('searchInput', isFocused ? 'is-focused' : '', value.length > 0 ? 'has-value' : '', className)"
  role="search"
  (submit)="$event.preventDefault()"
>
  <span class="bk-sym searchInput__icon" aria-hidden="true">search</span>

  <input
    type="text"
    class="searchInput__field"
    [(ngModel)]="value"
    [ngModelOptions]="{ standalone: true }"
    (input)="onInputChange($event)"
    (focus)="isFocused = true"
    (blur)="isFocused = false"
    [placeholder]="placeholder || 'Search...'"
    [attr.aria-label]="label || placeholder || 'Search'"
  />

  @if (value.length > 0) {
    <button
      type="button"
      class="searchInput__clear"
      aria-label="Clear search"
      (click)="clear()"
    >
      <span class="bk-sym" aria-hidden="true">close</span>
    </button>
  }
</form>
